"use client"
import { useState } from "react"
import { PersonaContext } from "./use-persona"
import type { Persona } from "./utils"

type PersonaProviderProps = {
  persona: Persona
  children: React.ReactNode
}

export function PersonaProvider({
  persona: initialPersona,
  children,
}: PersonaProviderProps) {
  const [persona, setPersona] = useState(initialPersona)

  function togglePersona() {
    switch (persona) {
      case "advanced":
        setPersona("collector")
        break
      case "collector":
        setPersona("advanced")
        break
    }
  }

  const value = { persona, setPersona, togglePersona }
  return (
    <PersonaContext.Provider value={value}>{children}</PersonaContext.Provider>
  )
}
